import { isServerError, useAxios } from 'src/hooks/use-axios';

const url = `${PRISMA_CONFIG.oldBackendUrl}/auth/login`;

export type LoginData = {
  email: string;
  password: string;
  token: string;
};

// copied from rest.d.ts
export type Role =
  | 'SHIPPER_USER'
  | 'TSO_USER'
  // | 'TSO_ADMIN' // not used in the frontend anymore
  | 'ADMIN'
  | 'SUPPORT_ADMIN'
  | 'PRISMA_EDITOR'
  | 'SSO_ADMIN'
  | 'SHIPPER_ADMIN';

// TODO: Incomplete typings, because some fields are optional and I don't know which one.
export type LoginResult = {
  email: string;
  countryCode: string;
  tsoName?: string;
  shipperName?: string;
  role: Role;
  originalRole?: Role; // probably available, if `proxyShipper` is `true`
  proxyShipper: boolean;
  firstName: string;
  lastName: string;
  eic?: string;
  userReferenceId: number;
  userId: number;
  referenceId: number;
  hasShipperRole?: boolean;
  // hasAwaitingShipperRole can only be true, if hasShipperRole is true as well
  hasAwaitingShipperRole: boolean;
  hasTsoAdminRole: boolean;
  // initially trackingSettings is an empty object - this should be treated as "allow: false"
  trackingSettings:
    | {
        allow: boolean;
        date: string;
      }
    | {};
  trackingUuid: string;
  userUuid: string;
};

export function useLogin() {
  const login = useAxios(
    (axios, signal, data: LoginData) =>
      axios.request<LoginResult>({
        signal,
        url,
        method: 'POST',
        data,
      }),
    {
      neededOnPageLoad: false,
      onError(error) {
        if (isServerError(error) && error.response.status === 500) {
          // note: bad credentials currently return as a 500 error
          // better: 400 and some generic flag to show that the input was wrong
          // even better: also add a specific flag to show that the input was wrong and
          // that it isn't a generic 400 error

          // bad credentials error looks like this:
          // - err.error.status: 500
          // - err.error.description: 'Bad credentials'
          // - err.error.errorCode : 'some generated number'

          // the description probably comes from spring security, so we can't rely on that
          // and need to treat every 500 error as a bad credentials error
          return error;
        } else if (isServerError(error) && error.response.status === 401) {
          // apparently new behaviour, but not rolled out to all stages, yet
          // for bad credentials you now get 401
          return error;
        } else {
          throw error;
        }
      },
    }
  );

  return login;
}
